import React, { Component, Fragment } from 'react';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import NavTop from '../../containers/NavTop/NavTop';
import {Row, Col, BackTop, Divider} from 'antd';
import QuoteBlock from '../../common/QuoteBlock/QuoteBlock';
import ApplicationsSection from '../../containers/ApplicationsSection/ApplicationsSection';
import ContactSection from '../../containers/ContactSection/ContactSection';

import './MarketPage.css';

const jsondataMarket = [
  {
    "headline":"The Health IT market is expected to grow from $11.6 billion in 2011 to $20 billion+ in 2019",
    "body":"Telemedicine makes up nearly one-fourth of the health IT market that is expected to increase to approximately $20 billion by 2019. Hospitals and other medical facilities are heavily investing in IT and health technology like telemedicine.",
    "source":"BCC Research",
    "sourceUrl":"http://www.bccresearch.com/market-research/healthcare/telemedicine-technologies-global-markets-hlc014e.html",
    "img":"https://www.realtimetouch.com/images/275/business-561387_1920.jpg",
  },
  {
    "headline":"90% of healthcare executives are planning new Telehealth programs",
    "body":"About 90% of healthcare executives surveyed report that their organizations have begun developing or already implemented a telemedicine program",
    "source":"Foley Telemedicine Survey",
    "sourceUrl":"http://www.foley.com/2014-telemedicine-survey-executive-summary/",
    "img":"https://www.realtimetouch.com/images/275/businessman-2606502_1920.jpg",
  },
  {
    "headline":"Huge growth potential: only 1.25 million telemedicine consultations of an estimated possible 400+ million consultations are being realized",
    "body":"As of 2016, telemedicine providers had market penetration of less than .5%, with an estimated 1.25 million telemedicine consultations of potentially  400+ million consultations, revealing huge potential in the market..",
    "source":"fshealth.com",
    "sourceUrl":"",
    "img":"https://www.realtimetouch.com/images/275/computer-1149148_1920.jpg",
  },
  {
    "headline":"Telemedicine solutions are poised to alleviate a shortage of health specialists in rural areas",
    "body":"15% of the U.S. population lives in rural areas and is currently underserved. There is a shortage of Specialists, less than half available compared ot that of urban residents, and telemedicine is seen as a solution.",
    "sourceUrl":"fshealth.com",
    "img":"https://www.realtimetouch.com/images/275/granny-2347552_1920.jpg",
  },
  {
    "headline":"Telemedicine is 25% of the global Health IT market, which is valued at $20+ billion by 2019",
    "body":"Telemedicine makes up nearly one-fourth of the health IT market that was valued at $15.6 billion in 2014 and is expected to increase to approximately $20 billion by 2019",
    "source":"IHS Press Release",
    "sourceUrl":"",
    "img":"https://www.realtimetouch.com/images/275/business-1989130_1920.jpg",
  },
  {
    "headline":"More than half of all US hospitals have a telemedicine program & adoption is increasing! ",
    "body":"American Telemedicine Association survey found that more than half of all US hospitals have a telemedicine program. 84% of respondents from C-level executives from for-profit and nonprofit hospitals, home health organizations and physician group practices believe the development of telemedicine services is either very important or important to their organizations.",
    "source":"American Telemedicine Association; Foley and Lardner LLP",
    "sourceUrl":"http://www.americantelemed.org/about-telemedicine/faqs",
    "img":"https://www.realtimetouch.com/images/275/doctor-1149149_1920.jpg",
  },
  {
    "headline":"The majority of Americans surveyed are willing to have a video doctor/nurse visit",
    "body":"64% of Americans are willing to have video visit with a doctor. Most patients are comfortable with having all of their health records securely available on the cloud.",
    "source":"American Well Telehealth Consumer Survey 2015; Cisco",
    "sourceUrl":"",
    "img":"https://www.realtimetouch.com/images/275/RTT-smart-home-2005993.jpg",
  },
  {
    "headline":"Telemedicine patients are increasing exponentially from 350,000 in 2013 to 7 million in 2018",
    "body":"According to the Cisco Customer Experience Report, the number of telemedicine patients will increase from 350,000 in 2013 to 7 million in 2018",
    "source":"Cisco Customer Experience Report",
    "sourceUrl":"http://newsroom.cisco.com/press-release-content?type=webcontent&articleId=1148539",
    "img":"https://www.realtimetouch.com/images/275/business-1989130_1920.jpg",
  },
  {
    "headline":"In a survey, 91% of health outcomes were scored as good or better via a Telehealth solution",
    "body":"According to an American Well survey, 91% of health outcomes were as good or better via telehealth. At least 70% of consumers reported that they’d rather have an online video visit to obtain a prescription than travel to their doctor’s office",
    "source":"American Well",
    "sourceUrl":"",
    "img":"https://www.realtimetouch.com/images/275/woman-2821623_1920.jpg",
  },
  {
    "headline":"1 in 3 parents with children under the age of 18 would have rather used Telemedicine for their doctor visit!",
    "body":"30% of parents with children under the age of 18 would prefer a video visit with a doctor for middle-of-the-night care over traditional options, such as the emergency room or a nurseline.",
    "source":"American Well (American Well Telehealth Consumer Survey 2015)",
    "sourceUrl":"",
    "img":"https://www.realtimetouch.com/images/275/RTT-smart-home-2005993.jpg",
  },
  {
    "headline":"71% of Healthcare Providers Use Telehealth",
    "body":"\"Adoption of telemedicine solutions or services has surged since this study was first conducted in 2014 from roughly 54 percent in 2014 to 71 percent in 2017,\" said the reports. \"After consistently growing 3.5 percent annually, based on study results adoption has increased roughly 9 percent since 2016.\"",
    "source":"mhealthintelligence.com",
    "sourceUrl":"",
    "img":"https://www.realtimetouch.com/images/275/gadget-2599498.jpg", 
  },
  {
    "headline":"Healthcare Executives Increasing Telemedicine",
    "body":"According to a recent healthcare executive study: \"Of those who have not yet adopted telemedicine, 86% say it is a medium to high priority....Three-quarters (75%) of respondents believe telemedicine has the potential to transform the standard of care for behavioral health/psychiatry, and approximately half believe it will transform care in neurology (53%), primary care (52%), and cardiology (48%)...75%) are interested in applying a telemedicine solution there in the future....The majority of respondents see positive ROI within three years in the outpatient clinic (75%), non-emergency hospital care (72%), emergency hospital care (71%), remote patient monitoring (68%), apps for virtual post-acute specialty care (63%)",
    "source":"Sage Growth Partners",
    "sourceUrl":"https://www.prnewswire.com/news-releases/telemedicines-transformational-value-across-the-care-continuum-is-clear---but-adoption-still-lags-300591279.html",
    "img":"https://www.realtimetouch.com/images/275/computer-1149148_1920.jpg"
  }
] 


class MarketPage extends Component {

  constructor(props){
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  
  componentWillMount(){
    let {pageOn} = this.props;
    document.body.scrollTop = 0;
    console.log(pageOn);
  }

  componentDidUpdate(prevProps) {
    document.body.scrollTop = 0;
  }
  
  renderMarketRowsDemo = (props) => {
    return (

      jsondataMarket.map((x)=>{
        return (

      <Fragment>
        <Row className="MarketPage--row">
          <Col md={8} className="MarketPage--col-stat">
            <img src={x.img} alt="Stat" className="MarketPage--col-stat-img img-rounded"/>
          </Col>
          <Col md={16} className="MarketPage--col-description">
            <h4 className="MarketPage--col-description-headline">{x.headline}</h4>
            <p className="MarketPage--col-description-body">{x.body} </p>
            <p className="MarketPage--col-description-footer">Source: {x.source}</p>
            
          </Col>
        </Row>
        <Row>
          <Col><Divider /></Col>
        </Row>
      </Fragment>
     
        )

      })

    )
  }

  render(){
   return (
    <Fragment>
      <Helmet>
          <meta charSet="utf-8" />
          <title>RealTimeTouch.com - Telemedicine Market Statistics</title>
          <link rel="canonical" href="http://www.realtimetouch.com/market/" />
      </Helmet>
      <NavTop pageOn={this.props.pageOn} />
      <BackTop />
          <div className="MarketPage--container-header center">
            <div className="MarketPage--container-color-overlay">
            </div>
          </div>
         
         <div className="MarketPage--subnavbar-container">
           <div className="MarketPage--subnavbar center">
           </div>  
           <div className="MarketPage--subnavbar2 center">
           </div>
           <h2 className="MarketPage--subnavbar-headline font-special-heading">Telemedicine Market Growth 2018-2022</h2>
         </div>
 
          <div className="MarketPage--headline-container-header">

            <div className="MarketPage--headline-container-inner">
              <h2 className="MarketPage--headline">A rapidly growing market with vast potential.</h2>
              <h4 className="MarketPage--subheadline">Real Time Touch has key intellectual property in this valuable market </h4>
              <div className="MarketPage--subheadline-chart-imgholder">
                <img className="MarketPage--subheadline-chart img-responsive" alt="chart" src="https://www.realtimetouch.com/images/general/Chart-Telemedicine-1.png" />
              </div>
              <div className="" style={{padding:10}}><QuoteBlock quote="1" /></div>
              <p className="MarketPage--body center"></p>
              <Divider />
              {this.renderMarketRowsDemo()}
            </div>
          </div>

          <div className="MarketPage--body-lower center">
            <ApplicationsSection />
            <ContactSection />
          </div>
          <div className=""></div>
          <div className=""></div>
          <div className=""></div>
          <div className=""></div>

     </Fragment>
    )
  }
}
 
 
 export default MarketPage;


// WEBPACK FOOTER //
// ./src/pages/MarketPage/MarketPage.js